/**
 * Brand mosaic, ported from the prototype's `mosaicHTML(cols, rows, colors, seed)`. The index
 * arithmetic is copied exactly so the generated pattern is the same one the prototype draws.
 */
import { type ReactElement, useMemo } from 'react';

const COLORS = ['#CF051E', '#F8BA3F', '#000000'];

export function Mosaic({
  cols,
  rows,
  seed = 5,
  className,
}: {
  cols: number;
  rows: number;
  seed?: number;
  className?: string;
}): ReactElement {
  const cells = useMemo(() => {
    const out: string[] = [];
    let i = seed;
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const on = (i * 37) % 7 < 4;
        out.push(on ? (COLORS[(i * 53) % COLORS.length] ?? 'transparent') : 'transparent');
        i++;
      }
    }
    return out;
  }, [cols, rows, seed]);

  return (
    <div
      className={['mosaic', className ?? ''].filter(Boolean).join(' ')}
      style={{ ['--cols' as string]: String(cols) }}
      aria-hidden="true"
    >
      {cells.map((background, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: fixed decorative grid, never reordered, the index is the cell identity
        <i key={index} style={{ background }} />
      ))}
    </div>
  );
}
